import { Roles } from 'enums';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';

export enum AccountManagementTabs {
  PROFILE = 'profile',
  /** Benachrichtigungen: which Mitteilungen/e-mails the user gets (Engagement Center). */
  NOTIFICATIONS = 'notifications',
  COMPANY = 'company',
  TENANTS = 'tenants',
  USERS = 'users',
  LICENSES = 'licenses',
  ADMIN_PANEL = 'admin-panel',
}

export interface AccountManagementTab {
  label: string;
  value: AccountManagementTabs;
  icon: React.ReactNode;
}

export enum ViewModes {
  ADMIN = 'admin',
  MANAGER = 'manager',
}

export interface LicenseShort {
  _id: string;
  product: string;
  billingType: string;
  isActive: boolean;
  isExpired: boolean;
  expiresAt: string | null;
}

export interface User {
  id: string;
  email: string;
  firstname: string;
  lastname: string;
  role: Roles;
  language: string;
  isActive?: boolean;
  invitationStatus?: 'pending' | 'expired' | 'accepted' | 'none';
  invitationExpiresAt?: string;
  tenant:
    | {
        id: string;
        _id: string;
        name: string;
      }
    | string;
  licenses?: LicenseShort[];
  onboardingDone: boolean;
  globalUser: string;
  takenActions: string[];
  optedOut: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CompanyInformationForm {
  company: string;
  street: string;
  zip: string;
  city: string;
  country: OptionType | null;
}

export enum ProductCategories {
  LEAD_BOOSTER = 'SAIA Sales',
  HR_BOOSTER = 'SAIA Recruiting',
  HR_SOURCING_BOOSTER = 'Sourcing Booster',
}

export enum RoleColorMap {
  ADMIN = '#d32f2f',
  BASIC = '#2e7d32',
  MANAGER = '#1976d2',
  AGENCY = '#6a1b9a',
}

export enum CompanySearchTypes {
  USER = 'user',
  TENANT = 'company-name',
  LINKEDIN = 'linkedin-account',
}

export enum TenantScopes {
  USERS = 'users',
  LICENSES = 'licenses',
}

export enum TenantSortBy {
  CREATED_AT_DESC = 'createdAt:desc',
  CREATED_AT_ASC = 'createdAt:asc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc',
  LICENSE_DESC = 'license:desc',
  LICENSE_ASC = 'license:asc',
}
